import { loader } from 'graphql.macro'

export default async function updateTickets ({ dataLoaders, variables }) {
  const schema = loader('./updateTickets.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.updateTickets
}
